import { useWidgetData } from "../Contexts/dashboardHooks";
import { resolveDateRange } from "../Utils/resolveDateRange";
import { WidgetInfoPopoverContent, type WidgetInfoRow } from "../WidgetComponents/WidgetInfoPopover";
import type { GaugeComponentSpec } from "../Processing/types";
import { SCALE_TYPE_LABELS } from "../Processing/gaugeScaleTypes";

export function GaugeInfo({ id }: { id: string }) {
  const data = useWidgetData(id);
  if (!data || data.type !== "gauge") return null;
  const spec = data.spec as GaugeComponentSpec;
  const misc = spec.gauge_builder_misc;
  const names = misc.selectedSubjectNames ?? [];
  const row: WidgetInfoRow = {
    queryId: spec.queryId,
    label: spec.display.title || "Gauge",
    aggLabel: { avg: "Average", sum: "Sum", best: "Best" }[misc.metricAgg] ?? misc.metricAgg,
    dates: resolveDateRange(misc),
    subjects: names.length > 0 ? names.join(", ") : "Full Team",
    scale: SCALE_TYPE_LABELS[spec.scale.type] ?? spec.scale.type,
  };
  return <WidgetInfoPopoverContent rows={[row]} />;
}
